export const API= 'https://api.fanyi.baidu.com/api/trans/vip/translate?';
export const APP_ID = "20180416000147222"; //这里修改APP_ID
export const APP_KEY = "IvlTe9ogsiBHl9Muevzu";//这里修改APP_KEY